import { ReactNode } from 'react';
import { DrawRequestMessageProvider } from '@context/DrawRequestMessageContext';

interface DrawRequestWrapperProps {
  children: ReactNode;
}

export default function DrawRequestWrapper({
  children,
}: DrawRequestWrapperProps) {
  return <DrawRequestMessageProvider>{children}</DrawRequestMessageProvider>;
}
